export default __webpack_public_path__ + "static/media/ucParkMap.4f367e21.png";